import { FilingPeriodEnum } from "@exonn/js-sdk";

/**
 * Zeitraum einer ZM so, wie der Bearbeiter ihn gewählt hat: „05/2026“ für einen Monat,
 * „Q2/2026“ für ein Quartal. Der Monat ist beim Quartal der erste Monat des Quartals.
 */
export const zmPeriodLabel = (
  year: number,
  month: number,
  type: FilingPeriodEnum,
): string =>
  type === FilingPeriodEnum.Quarterly
    ? `Q${Math.floor((month - 1) / 3) + 1}/${year}`
    : `${String(month).padStart(2, "0")}/${year}`;
